/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            path: '',
            component: () => import('./layouts/full-page/FullPage.vue'),
            children: [       
                {
                    path: '/',
                    redirect: '/login'
                },                
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/concept/login/Login.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/sair',
                    name: 'page-exir',
                    component: () => import('@/views/concept/login/Login.vue'),
                    meta: {
                        rule: 'editor',
                        origem: 'click-menu-sair'
                    }
                },
                {
                    path: '/login/:nomeCentral',
                    name: 'page-login-central',
                    component: () => import('@/views/concept/login/Login.vue'),
                    props: true,
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/esqueci-minha-senha',
                    name: 'page-esqueci-minha-senha',
                    component: () => import('@/views/concept/login/EsqueciMinhaSenha.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/alterar-senha',
                    name: 'page-alterar-senha',
                    component: () => import('@/views/concept/login/AlterarSenha.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/inspecao-pneu',
                    name: 'page-login-inspecao',
                    component: () => import('@/views/concept/login/LoginInspecao.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },                
                {
                    path: '/login-acesso-temporario/:dados',
                    name: 'page-acesso-temporario',
                    component: () => import('@/views/concept/login/LoginAcessoTemporario.vue'),
                    props: true,
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/tratativa-infracao',
                    name: 'page-login-tratativa-infracao',
                    component: () => import('@/views/concept/frota/tratativa-infracoes/LoginTratativaInfracao.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/sair-tratativa',
                    name: 'page-exit-tratativa',
                    component: () => import('@/views/concept/frota/tratativa-infracoes/LoginTratativaInfracao.vue'),
                    meta: {
                        rule: 'editor',
                        origem: 'click-menu-sair'
                    }
                },
                {
                    path: '/tratar-infracoes',
                    name: 'page-login-tratar-infracao',
                    component: () => import('@/views/concept/frota/tratativa-infracoes/TratarInfracoes.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/controle-portaria',
                    name: 'page-login-controle-portaria',
                    component: () => import('@/views/concept/login/LoginControlePortaria.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/registrar-controle-portaria',
                    name: 'page-registrar-controle-portaria',                    
                    component: () => import('@/views/concept/frota/controle-portaria/ControleEntradaSaidaManualInserir.vue'),
                    meta: {
                        rule: 'editor',
                        origem: 'tela-solo'
                    }
                },
                {
                    path: '/pesquisar-controle-portaria',
                    name: 'page-pesquisar-controle-portaria',                    
                    component: () => import('@/views/concept/frota/controle-portaria/ControleEntradaSaidaManualMobile.vue'),
                    meta: {
                        rule: 'editor',
                        origem: 'tela-solo'
                    }
                },
                {
                    path: '/sair-controle-portaria',
                    name: 'page-exit-controle-portaria',
                    component: () => import('@/views/concept/login/LoginControlePortaria.vue'),
                    meta: {
                        rule: 'editor',
                        origem: 'click-menu-sair'
                    }
                },
                {
                    path: '/mensagem-conclusao-agenda/:p1/:p2/:p3/:acao',
                    name: 'page-conclusao-agenda',
                    component: () => import('@/views/concept/frota/agenda-eventos/ResultadoAlteracaoStatusAgenda.vue'),
                    props: true,
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/vendedor/login',
                    name: 'page-login-vendedor-roteirizacao',
                    component: () => import('@/views/concept/login/LoginVendedorRoteirizacao.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/vendedor/gerenciamento-pedidos',
                    name: 'page-vendedor-gerenciamento-pedidos',                    
                    component: () => import('@/views/concept/roteirizacao/gerenciamento-pedidos/GerenciamentoPedidos.vue'),                    
                    meta: {    
                        pageTitle: 'Gerenciamento de Pedidos',                                           
                        rule: 'editor'
                    },
                },
            ]
        },
        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('@/layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                {
                    path: '/mapa',
                    name: 'mapa',
                    component: () => import('@/views/concept/mapa/MapaPrincipal.vue'),
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                {
                    path: '/fast',
                    name: 'fast',
                    component: () => import('@/views/concept/versao-fast/FastHome.vue'),
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                {
                    path: '/fast-percurso',
                    name: 'fast-percurso',
                    component: () => import('@/views/concept/versao-fast/FastPercursos.vue'),
                    props: true ,
                    meta: {                                               
                        rule: 'editor'
                    },
                },                
                {
                    path: '/grid',
                    name: 'grid',
                    component: () => import('@/views/concept/grid/Grid.vue'),
                    meta: {                       
                        pageTitle: 'Grid',                        
                        rule: 'editor'
                    },
                },
                {
                    path: '/dashboard/veiculos',
                    name: 'dashboard-veiculos',
                    component: () => import('@/views/concept/dashboard/DashboardVeiculos.vue'),
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                {
                    path: '/dashboard/despesas',
                    name: 'dashboard-despesas',
                    component: () => import('@/views/concept/dashboard/DashboardDespesas.vue'),
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                {
                    path: '/dashboard/veiculos/impressao',
                    name: 'dashboard-imprimir-agenda-eventos',
                    props: true ,
                    component: () => import('@/views/concept/dashboard/ImpressaoListaAgendaEvento.vue'),
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                {
                    path: '/dashboard/motoristas',
                    name: 'dashboard-motoristas',
                    component: () => import('@/views/concept/dashboard/DashboardMotoristas.vue'),
                    props: true ,
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                {
                    path: '/dashboard/individual/motorista',
                    name: 'dashboard-individual-motorista',
                    component: () => import('@/views/concept/dashboard/DashboardIndividualMotorista.vue'),
                    props: true ,
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                {
                    path: '/dashboard/individual/divisao',
                    name: 'dashboard-individual-divisao',
                    component: () => import('@/views/concept/dashboard/DashboardIndividualDivisao.vue'),
                    props: true ,
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                {
                    path: '/dashboard/telemetria',
                    name: 'dashboard-telemetria',
                    component: () => import('@/views/concept/dashboard/DashboardTelemetria.vue'),
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                {
                    path: '/dashboard/cameras',
                    name: 'dashboard-cameras',
                    component: () => import('@/views/concept/dashboard/DashboardCameras.vue'),
                    meta: {           
                        pageTitle: 'Video Telemetria',                                    
                        rule: 'editor'
                    },
                },
                {
                    path: '/avisos/avisosDoDia',
                    name: 'avisos-do-dia',
                    component: () => import('@/views/concept/avisos/AvisosDoDia.vue'),
                    meta: {                       
                        pageTitle: 'Avisos do Dia',
                        rule: 'editor'
                    },
                }, 
                {
                    path: '/avisos/avisos',
                    name: 'avisos',
                    component: () => import('@/views/concept/avisos/Avisos.vue'),
                    meta: {                       
                        pageTitle: 'Avisos',
                        rule: 'editor'
                    }
                    
                }, 
                {
                    path: '/configuracao',
                    name: 'configuracao',
                    component: () => import('@/views/concept/configuracao/Configuracoes.vue'),
                    meta: {    
                        pageTitle: 'Configurações',                                           
                        rule: 'editor'
                    },
                }, 

                {
                    path: '/configuracao/som-aviso/pesquisar',
                    name: 'configuracao-som-aviso',
                    component: () => import('@/views/concept/configuracao/som-aviso/SomAviso.vue'),
                    meta: {                       
                        pageTitle: 'Configurações do Som de Avisos',                        
                        parent: 'configuracao',
                        parentTitle: 'Configurações',
                        rule: 'editor'                        
                    }                    
                },                   
                {
                    path: '/configuracao/som-aviso/editar',
                    name: 'configuracao-som-aviso-edit',
                    component: () => import('@/views/concept/configuracao/som-aviso/SomAvisoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Configuração do Som de Aviso',
                        rule: 'editor',
                        breadcrumb: [                         
                            { title: 'Configuração'},
                            { title: 'Divisão de Veiculos', active: true }
                        ],
                        parent: 'configuracao',
                    },
                },

                {
                    path: '/configuracao/divisao-veiculo/pesquisar',
                    name: 'configuracao-divisao-veiculo',
                    component: () => import('@/views/concept/configuracao/divisao/Divisao.vue'),
                    meta: {                       
                        pageTitle: 'Divisões de Veiculos',                        
                        parent: 'configuracao',
                        parentTitle: 'Configurações',
                        rule: 'editor'                        
                    }                    
                },                   
                {
                    path: '/configuracao/divisao-veiculo/editar',
                    name: 'configuracao-divisao-veiculo-edit',
                    component: () => import('@/views/concept/configuracao/divisao/DivisaoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Divisão de Veiculos',
                        rule: 'editor',
                        breadcrumb: [                         
                            { title: 'Configuração'},
                            { title: 'Divisão de Veiculos', active: true }
                        ],
                        parent: 'configuracao',
                    },
                },
                {
                    path: '/configuracao/divisao-motorista/pesquisar',
                    name: 'configuracao-divisao-motorista',
                    component: () => import('@/views/concept/configuracao/divisao-motoristas/DivisaoMotorista.vue'),
                    meta: {           
                        parent: 'configuracao',            
                        pageTitle: 'Divisões de Motoristas',                        
                        parentTitle: 'Configurações',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/divisao-motorista/editar',
                    name: 'configuracao-divisao-motorista-edit',
                    component: () => import('@/views/concept/configuracao/divisao-motoristas/DivisaoMotoristaEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Divisão de Motoristas',
                        rule: 'editor',
                        breadcrumb: [                         
                            { title: 'Configuração'},
                            { title: 'Divisão de Motoristas', active: true }
                        ]
                    },
                },
                {
                    path: '/configuracao/divisao-controle-acesso/pesquisar',
                    name: 'configuracao-divisao-controle-acesso',
                    component: () => import('@/views/concept/configuracao/divisao-controle-acesso/DivisaoControleAcesso.vue'),
                    meta: {           
                        parent: 'configuracao',            
                        pageTitle: 'Divisões de Controle de Acesso',                        
                        parentTitle: 'Configurações',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/divisao-controle-acesso/editar',
                    name: 'configuracao-divisao-controle-acesso-edit',
                    component: () => import('@/views/concept/configuracao/divisao-controle-acesso/DivisaoControleAcessoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Divisão de Controle de Acesso',
                        rule: 'editor',
                        breadcrumb: [                         
                            { title: 'Configuração'},
                            { title: 'Divisão de Motoristas', active: true }
                        ]
                    },
                },
                {
                    path: '/configuracao/corLocalidade/pesquisar',
                    name: 'configuracao-cor-localidade',
                    component: () => import('@/views/concept/configuracao/cor-localidade/CorLocalidade.vue'),
                    meta: {                       
                        pageTitle: 'Cores Localidade',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/corLocalidade/editar',
                    name: 'configuracao-cor-localidade-edit',
                    component: () => import('@/views/concept/configuracao/cor-localidade/CorLocalidadeEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Cor Localidade',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/motorista/pesquisar',
                    name: 'configuracao-motorista',
                    component: () => import('@/views/concept/configuracao/motorista/Motorista.vue'),
                    meta: {                       
                        pageTitle: 'Motoristas',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/motorista/editar',
                    name: 'configuracao-motorista-edit',
                    component: () => import('@/views/concept/configuracao/motorista/MotoristaEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Motorista',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/veiculo/alterar',
                    name: 'configuracao-alterar-veiculo',
                    component: () => import('@/views/concept/configuracao/alteracao-veiculo/AlterarVeiculo.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Alteração Veículo',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/veiculo/alterar-dados-contato',
                    name: 'configuracao-alterar-dados-contato-veiculo',
                    component: () => import('@/views/concept/configuracao/alteracao-veiculo/AlteracaoDadosContato.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Alteração Dados de Contato',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/perimetro/pesquisar',
                    name: 'configuracao-perimetro',
                    component: () => import('@/views/concept/configuracao/perimetro/Perimetro.vue'),
                    meta: {                       
                        pageTitle: 'Perímetros',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/perimetro/editar',
                    name: 'configuracao-perimetro-edit',
                    component: () => import('@/views/concept/configuracao/perimetro/PerimetroEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Perímetro',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/atuadores/atuador',
                    name: 'configuracao-atuadores-atuador',
                    component: () => import('@/views/concept/configuracao/atuadores/Atuador.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Atuadores',
                        rule: 'editor'
                    },
                },

                {
                    path: '/configuracao/perfil-cores/pesquisar',
                    name: 'configuracao-perfil-cores',
                    component: () => import('@/views/concept/configuracao/perfil-cores-velocidade-percurso/PerfilCoresVelocidadePercurso.vue'),
                    meta: {                       
                        pageTitle: 'Perfis de Cores de Velocidades nos Percursos',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/perfil-cores/editar',
                    name: 'configuracao-perfil-cores-edit',
                    component: () => import('@/views/concept/configuracao/perfil-cores-velocidade-percurso/PerfilCoresVelocidadePercursoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Perfil de Cores de Velocidades no Percurso',
                        rule: 'editor'
                    },
                },       

                {
                    path: '/relatorios',
                    name: 'relatorios',
                    component: () => import('@/views/concept/relatorios/Relatorios2.vue'),
                    meta: {    
                        pageTitle: 'Relatorios',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/bloqueio',
                    name: 'bloqueio',
                    component: () => import('@/views/concept/configuracao/atuadores/Bloqueio.vue'),
                    meta: {    
                        pageTitle: 'Bloqueio',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/percursos',
                    name: 'percursos',
                    component: () => import('@/views/concept/percurso/Percursos.vue'),
                    props: true ,
                    meta: {                                                                   
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/categoria-aviso/pesquisar',
                    name: 'configuracao-categoria-aviso',
                    component: () => import('@/views/concept/configuracao/categoria-aviso/CategoriaAviso.vue'),
                    meta: {                       
                        pageTitle: 'Categoria Avisos',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/categoria-aviso/editar',
                    name: 'configuracao-categoria-aviso-edit',
                    component: () => import('@/views/concept/configuracao/categoria-aviso/CategoriaAvisoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Categoria Aviso',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/pontuacao-aviso/pesquisar',
                    name: 'configuracao-pontuacao-aviso',
                    component: () => import('@/views/concept/configuracao/pontuacao-aviso/PontuacaoAviso.vue'),
                    meta: {                       
                        pageTitle: 'Pontuações Avisos',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/pontuacao-aviso/editar',
                    name: 'configuracao-pontuacao-aviso-edit',
                    component: () => import('@/views/concept/configuracao/pontuacao-aviso/PontuacaoAvisoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Pontuação Aviso',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/pessoa-rfid/pesquisar',
                    name: 'configuracao-pessoa-rfid',
                    component: () => import('@/views/concept/configuracao/pessoa-rfid/PessoaRFID.vue'),
                    meta: {                       
                        pageTitle: 'Pessoas',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/pessoa-rfid/editar',
                    name: 'configuracao-pessoa-rfid-edit',
                    component: () => import('@/views/concept/configuracao/pessoa-rfid/PessoaRFIDEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Pessoa',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/veiculo-lote/alterar',
                    name: 'configuracao-alterar-veiculo-lote',
                    component: () => import('@/views/concept/configuracao/alteracao-veiculo-lote/AlterarVeiculoLote.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Alteração Veículo Em Lote',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/categoria-veiculo/pesquisar',
                    name: 'configuracao-categoria-veiculo',
                    component: () => import('@/views/concept/configuracao/categoria-veiculo/CategoriaVeiculo.vue'),
                    meta: {                       
                        pageTitle: 'Categorias Veículos',
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/configuracao/categoria-veiculo/editar',
                    name: 'configuracao-categoria-veiculo-edit',
                    component: () => import('@/views/concept/configuracao/categoria-veiculo/CategoriaVeiculoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Categoria Veiculo',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/controle-acesso/log',
                    name: 'configuracao-controle-acesso-log',
                    component: () => import('@/views/concept/configuracao/controle-acesso/LogAcesso.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Log Acesso',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frotas',
                    name: 'frotas',
                    component: () => import('@/views/concept/frota/MenuFrotas.vue'),
                    meta: {    
                        pageTitle: 'Controles',                                           
                        rule: 'editor'
                    },
                },                 
                {
                    path: '/frota/agenda-eventos/pesquisar',
                    name: 'frota-agenda-eventos',
                    component: () => import('@/views/concept/frota/agenda-eventos/AgendaEventos.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Agenda de Eventos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/agenda-eventos/editar',
                    name: 'frota-agenda-eventos-edit',
                    component: () => import('@/views/concept/frota/agenda-eventos/AgendaEventosEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Agenda de Evento',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/agenda-eventos/imprimir',
                    name: 'frota-agenda-eventos-print',
                    component: () => import('@/views/concept/frota/agenda-eventos/ImpressaoAgendaEvento.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Impressão Evento',
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/fornecedores/pesquisar',
                    name: 'frota-fornecedor',
                    component: () => import('@/views/concept/frota/fornecedores/Fornecedores.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Favorecidos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/fornecedores/editar',
                    name: 'frota-fornecedor-edit',
                    component: () => import('@/views/concept/frota/fornecedores/FornecedoresEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Favorecido',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/categoria-ponto-interesse/pesquisar',
                    name: 'frota-categoria-ponto-interesse',
                    component: () => import('@/views/concept/frota/categoria-ponto-interesse/CategoriaPontoInteresse.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Grupos Ponto de Interesse',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/categoria-ponto-interesse/editar',
                    name: 'frota-categoria-ponto-interesse-edit',
                    component: () => import('@/views/concept/frota/categoria-ponto-interesse/CategoriaPontoInteresseEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Categoria Ponto de Interesse',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/receita/pesquisar',
                    name: 'frota-receita',
                    component: () => import('@/views/concept/frota/receitas/Receita.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Receitas de Veículos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/receita/editar',
                    name: 'frota-receita-edit',
                    component: () => import('@/views/concept/frota/receitas/ReceitaEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Receita de Veículos',
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/receita/inserir-varios',
                    name: 'frota-receita-insert-multi',
                    component: () => import('@/views/concept/frota/receitas/ReceitaInsertMulti.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Inserção múltipla de receitas de veículo',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/despesa/pesquisar',
                    name: 'frota-despesa',
                    component: () => import('@/views/concept/frota/despesas/Despesa.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Despesas de Veículos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/despesa/editar',
                    name: 'frota-despesa-edit',
                    component: () => import('@/views/concept/frota/despesas/DespesaEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Despesa de Veículos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/despesa/importar',
                    name: 'frota-despesa-import',
                    component: () => import('@/views/concept/frota/despesas/DespesaImportar.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Despesa de Veículos - Importação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/despesa/inserir-varios',
                    name: 'frota-despesa-insert-multi',
                    component: () => import('@/views/concept/frota/despesas/DespesaInsertMulti.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Inserção múltipla de despesas de veículo',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/despesa/imprimir',
                    name: 'frota-despesa-print',
                    component: () => import('@/views/concept/frota/despesas/ImpressaoDespesas.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Impressão Despesa',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/tanque-combustivel/pesquisar',
                    name: 'frota-tanque-combustivel',
                    component: () => import('@/views/concept/frota/tanques-combustivel/TanqueCombustivel.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Tanques de Combustível',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/tanque-combustivel/editar',
                    name: 'frota-tanque-combustivel-edit',
                    component: () => import('@/views/concept/frota/tanques-combustivel/TanqueCombustivelEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Tanque de Combustível',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/ponto-interesse/importar',
                    name: 'frota-ponto-interesse-import',
                    component: () => import('@/views/concept/frota/ponto-interesse/PontoInteresseImportar.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Pontos de Interesse - Importação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/compra-combustivel/pesquisar',
                    name: 'frota-compra-combustivel',
                    component: () => import('@/views/concept/frota/compra-combustivel/CompraCombustivel.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Compras de Combustível',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/compra-combustivel/editar',
                    name: 'frota-compra-combustivel-edit',
                    component: () => import('@/views/concept/frota/compra-combustivel/CompraCombustivelEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Compra de Combustível',
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/movimentacao-combustivel/pesquisar',
                    name: 'frota-movimentacao-combustivel',
                    component: () => import('@/views/concept/frota/movimentacao-combustivel/MovimentacaoCombustivel.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Movimentações de Combustível',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/movimentacao-combustivel/editar',
                    name: 'frota-movimentacao-combustivel-edit',
                    component: () => import('@/views/concept/frota/movimentacao-combustivel/MovimentacaoCombustivelEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Movimentações de Combustível',
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/ponto-interesse/pesquisar',
                    name: 'frota-ponto-interesse',
                    component: () => import('@/views/concept/frota/ponto-interesse/PontoInteresse.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Pontos de Interesse',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/ponto-interesse/editar',
                    name: 'frota-ponto-interesse-edit',
                    component: () => import('@/views/concept/frota/ponto-interesse/PontoInteresseEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Ponto de Interesse',
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/rotograma/pesquisar',
                    name: 'frota-rotograma',
                    component: () => import('@/views/concept/frota/rotograma/Rotograma.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Pontos de Rotograma',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/rotograma/editar',
                    name: 'frota-rotograma-edit',
                    component: () => import('@/views/concept/frota/rotograma/RotogramaEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Ponto de Rotograma',
                        rule: 'editor'
                    },
                },

                {
                    path: '/configuracao/mensagem-teclado/pesquisar',
                    name: 'configuracao-mensagem-teclado',
                    component: () => import('@/views/concept/configuracao/mensagem-teclado/MensagemTeclado.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Mensagens de Teclados',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/mensagem-teclado/editar',
                    name: 'configuracao-mensagem-teclado-edit',
                    component: () => import('@/views/concept/configuracao/mensagem-teclado/MensagemTecladoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Mensagem de Teclado',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/mensagem-teclado/enviar',
                    name: 'configuracao-mensagem-teclado-enviar',
                    component: () => import('@/views/concept/configuracao/mensagem-teclado/MensagemTecladoEnviar.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Enviar Mensagem de Teclado',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/mensagem-teclado/contra-senha',
                    name: 'configuracao-mensagem-teclado-contra-senha',
                    component: () => import('@/views/concept/configuracao/mensagem-teclado/MensagemTecladoContraSenha.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Gerador Contra Senha',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/mensagem-teclado/auditoria',
                    name: 'configuracao-mensagem-teclado-auditoria',
                    component: () => import('@/views/concept/configuracao/mensagem-teclado/MensagemTecladoAuditoria.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Registros de Auditoria',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/acesso/pesquisar',
                    name: 'configuracao-grupo-veiculo',
                    component: () => import('@/views/concept/configuracao/controle-acesso/GrupoVeiculo.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Controle de Acesso',
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/acesso/editar',
                    name: 'configuracao-grupo-veiculo-edit',
                    component: () => import('@/views/concept/configuracao/controle-acesso/GrupoVeiculoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Acesso',
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens',
                    name: 'controle-viagens',
                    component: () => import('@/views/concept/controle-viagens/MenuControleViagens.vue'),
                    meta: {    
                        pageTitle: 'Controles de Viagens',                                           
                        rule: 'editor'
                    },
                },  
                {
                    path: '/controle-viagens/zonas-viagens/pesquisar',
                    name: 'controle-viagens-zona-viagem',
                    component: () => import('@/views/concept/controle-viagens/zonas-viagens/ZonasViagens.vue'),
                    meta: {                       
                        pageTitle: 'Zonas de Viagens',                                                
                        rule: 'editor'
                    },
                },                   
                {
                    path: '/controle-viagens/zonas-viagens/editar',
                    name: 'controle-viagens-zona-viagem-edit',
                    component: () => import('@/views/concept/controle-viagens/zonas-viagens/ZonasViagensEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Zona de Viagem',
                        rule: 'editor'                        
                    },
                }, 
                {
                    path: '/controle-viagens/controle-entrada-saida',
                    name: 'controle-viagens-controle-entrada-saida',
                    component: () => import('@/views/concept/controle-viagens/controle-entrada-saida/ControleEntradaSaida.vue'),
                    meta: {    
                        pageTitle: 'Controles de Entrada/Saída de Veículos',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/controle-entrada-saida-edit',
                    name: 'controle-viagens-controle-entrada-saida-edit',                    
                    component: () => import('@/views/concept/controle-viagens/controle-entrada-saida/ControleEntradaSaidaEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Controle de Entrada/Saída',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/controle-entrada-saida-manual',
                    name: 'controle-viagens-controle-entrada-saida-manual',
                    component: () => import('@/views/concept/frota/controle-portaria/ControleEntradaSaidaManual.vue'),
                    meta: {    
                        pageTitle: 'Registros de Entrada/Saída de Veículos',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/controle-entrada-saida-manual-edit',
                    name: 'controle-viagens-controle-entrada-saida-manual-edit',                    
                    component: () => import('@/views/concept/frota/controle-portaria/ControleEntradaSaidaManualEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Registro de Entrada/Saída',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/controle-entrada-saida-manual-fila',
                    name: 'controle-viagens-controle-entrada-saida-manual-fila',                    
                    component: () => import('@/views/concept/frota/controle-portaria/ControleEntradaSaidaManualFilaView.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Fila Virtual',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/controle-viagens/rotas-viagem/pesquisar',
                    name: 'controle-viagens-rotas-viagem',                    
                    component: () => import('@/views/concept/controle-viagens/rotas-viagem/RotasControleViagem.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Rotas de Controle de Viagem',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/rotas-viagem/editar',
                    name: 'controle-viagens-rotas-viagem-edit',                    
                    component: () => import('@/views/concept/controle-viagens/rotas-viagem/RotasControleViagemEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Rota de Controle de Viagem',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/rotas-viagem/imprimir',
                    name: 'controle-viagens-rotas-viagem-imprimir',                    
                    component: () => import('@/views/concept/controle-viagens/rotas-viagem/ImpressaoRotaViagem.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Impressão Rota de Controle de Viagem',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/controle-viagem/pesquisar',
                    name: 'controle-viagens-controle-viagem',                    
                    component: () => import('@/views/concept/controle-viagens/controle-viagens/ControleViagem.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Controles de Viagens',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/controle-viagem/editar',
                    name: 'controle-viagens-controle-viagem-edit',                    
                    component: () => import('@/views/concept/controle-viagens/controle-viagens/ControleViagemEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Controle de Viagem',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/controle-simples-viagem/editar',
                    name: 'controle-viagens-controle-simples-viagem-edit',                    
                    component: () => import('@/views/concept/controle-viagens/controle-viagens/ControleSimplesViagemEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Controle Simples de Viagem',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/controle-viagens/equipamentos-viagens/pesquisar',
                    name: 'controle-viagens-equipamentos-viagens',                    
                    component: () => import('@/views/concept/controle-viagens/equipamentos-viagens/EquipamentoViagem.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Equipamentos de Viagens',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/equipamentos-viagens/editar',
                    name: 'controle-viagens-equipamentos-viagens-edit',                    
                    component: () => import('@/views/concept/controle-viagens/equipamentos-viagens/EquipamentoViagemEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Equipamento de Viagem',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/controle-viagens/monitriip/pesquisar',
                    name: 'controle-viagens-monitriip',                    
                    component: () => import('@/views/concept/controle-viagens/monitriip/Monitriip.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Eventos Monitriip',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/monitriip/editar',
                    name: 'controle-viagens-monitriip-edit',                    
                    component: () => import('@/views/concept/controle-viagens/monitriip/MonitriipEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Evento Monitriip',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/roteirizacao',
                    name: 'roteirizacao',
                    component: () => import('@/views/concept/roteirizacao/MenuRoteirizacao.vue'),
                    meta: {    
                        pageTitle: 'Roteirização',                                           
                        rule: 'editor'
                    },
                }, 
                {
                    path: '/roteirizacao/pedido/pesquisar',
                    name: 'roteirizacao-pedido',                    
                    component: () => import('@/views/concept/roteirizacao/pedidos/Pedido.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Pedidos',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/pedido/editar',
                    name: 'roteirizacao-pedido-edit',                    
                    component: () => import('@/views/concept/roteirizacao/pedidos/PedidoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Pedido',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/zona/pesquisar',
                    name: 'roteirizacao-zona',                    
                    component: () => import('@/views/concept/roteirizacao/zonas/Zona.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Zonas de Roteirização',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/zona/editar',
                    name: 'roteirizacao-zona-edit',                    
                    component: () => import('@/views/concept/roteirizacao/zonas/ZonaEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Zona de Roteirização',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/loja/pesquisar',
                    name: 'roteirizacao-loja',                    
                    component: () => import('@/views/concept/roteirizacao/lojas/Loja.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Lojas de Roteirização',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/loja/editar',
                    name: 'roteirizacao-loja-edit',                    
                    component: () => import('@/views/concept/roteirizacao/lojas/LojaEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Loja de Roteirização',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/vendedor/pesquisar',
                    name: 'roteirizacao-vendedor',                    
                    component: () => import('@/views/concept/roteirizacao/vendedores/Vendedor.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Vendedores de Roteirização',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/vendedor/editar',
                    name: 'roteirizacao-vendedor-edit',                    
                    component: () => import('@/views/concept/roteirizacao/vendedores/VendedorEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Vendedor de Roteirização',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/tipo-ocorrencia/pesquisar',
                    name: 'roteirizacao-tipo-ocorrencia',                    
                    component: () => import('@/views/concept/roteirizacao/tipo-ocorrencia/TipoOcorrencia.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Tipo de Ocorrências',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/tipo-ocorrencia/editar',
                    name: 'roteirizacao-tipo-ocorrencia-edit',                    
                    component: () => import('@/views/concept/roteirizacao/tipo-ocorrencia/TipoOcorrenciaEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Tipo de Ocorrência',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/rota/pesquisar',
                    name: 'roteirizacao-rota',                    
                    component: () => import('@/views/concept/roteirizacao/rotas/Rota.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirizações',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/rota/editar',
                    name: 'roteirizacao-rota-edit',                    
                    component: () => import('@/views/concept/roteirizacao/rotas/RotaEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirização',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/rota/itinerario',
                    name: 'roteirizacao-rota-itinerario',                    
                    component: () => import('@/views/concept/roteirizacao/rotas/ItinerarioRotaEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Itinerario da Roteirização',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/rota/itinerarios',
                    name: 'roteirizacao-rota-itinerarios',                    
                    component: () => import('@/views/concept/roteirizacao/rotas/Itinerarios.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Itinerários',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/rota/importar-pathfinder',
                    name: 'roteirizacao-rota-importar-pathfinder',                    
                    component: () => import('@/views/concept/roteirizacao/importador-pedidos/ImportadorPathFinder.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Importador do Pathfinder',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/roteirizador/etapa1',
                    name: 'roteirizacao-roteirizador-etapa1',                    
                    component: () => import('@/views/concept/roteirizacao/roteirizador/RoteirizadorEtapa1.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirizador',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/roteirizador/etapa2',
                    name: 'roteirizacao-roteirizador-etapa2',
                    component: () => import('@/views/concept/roteirizacao/roteirizador/RoteirizadorEtapa2.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirizador',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/roteirizador/etapa3',
                    name: 'roteirizacao-roteirizador-etapa3',
                    component: () => import('@/views/concept/roteirizacao/roteirizador/RoteirizadorEtapa3.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirizador',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/importador-pedidos',
                    name: 'roteirizacao-importador-pedidos',
                    component: () => import('@/views/concept/roteirizacao/importador-pedidos/ImportadorPedidos.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Importação de Pedidos',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/importador-pedidos-atak',
                    name: 'roteirizacao-importador-pedidos-atak',
                    component: () => import('@/views/concept/roteirizacao/importador-pedidos/ImportadorPedidosAtak.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Importação de Pedidos - ATAK',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/visualizacao-roteirizacao',
                    name: 'roteirizacao-visualizacao-roteirizacao',
                    component: () => import('@/views/concept/roteirizacao/monitoramento-rotas/HistoricoRotas.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Visualização Roteirização',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/monitoramento-roteirizacao',
                    name: 'roteirizacao-monitoramento-roteirizacao',
                    component: () => import('@/views/concept/roteirizacao/monitoramento-rotas/MonitoramentoRotas.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Monitoramento de Rotas',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/registro-paradas',
                    name: 'roteirizacao-registro-paradas',
                    component: () => import('@/views/concept/roteirizacao/registro-paradas/RegistroParadas.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Visualização de Registro de Paradas',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/automatizador-roteirizacao/pesquisar',
                    name: 'roteirizacao-automatizador-roteirizacao',                    
                    component: () => import('@/views/concept/roteirizacao/automatizador-roteirizacao/RotaAutomatizada.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirizações Automatizadas',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/automatizador-roteirizacao/editar',
                    name: 'roteirizacao-automatizador-roteirizacao-edit',                    
                    component: () => import('@/views/concept/roteirizacao/automatizador-roteirizacao/RotaAutomatizadaEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirização Automatizada',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/roteirizacao/roteirizador-poi/etapa1',
                    name: 'roteirizacao-roteirizador-poi-etapa1',                    
                    component: () => import('@/views/concept/roteirizacao/roteirizador-poi/RoteirizadorEtapa1.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirizador',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/roteirizador-poi/etapa2',
                    name: 'roteirizacao-roteirizador-poi-etapa2',
                    component: () => import('@/views/concept/roteirizacao/roteirizador-poi/RoteirizadorEtapa2.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirizador',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/roteirizador-poi/etapa3',
                    name: 'roteirizacao-roteirizador-poi-etapa3',
                    component: () => import('@/views/concept/roteirizacao/roteirizador-poi/RoteirizadorEtapa3.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Roteirizador',                                           
                        rule: 'editor'
                    },
                },
                
                {
                    path: '/controle-pneus',
                    name: 'controle-pneus',
                    component: () => import('@/views/concept/pneus/MenuPneus.vue'),
                    meta: {    
                        pageTitle: 'Controle de Pneus',                                           
                        rule: 'editor'
                    },
                }, 
                {
                    path: '/controle-pneus/almoxarifado/pesquisar',
                    name: 'controle-pneus-almoxarifado',                    
                    component: () => import('@/views/concept/pneus/almoxarifados/Almoxarifado.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Almoxarifados',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/almoxarifado/editar',
                    name: 'controle-pneus-almoxarifado-edit',                    
                    component: () => import('@/views/concept/pneus/almoxarifados/AlmoxarifadoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Almoxarifado',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/fabricante-pneu/pesquisar',
                    name: 'controle-pneus-fabricante-pneu',                    
                    component: () => import('@/views/concept/pneus/fabricantes-pneu/FabricantePneu.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Fabricantes Pneu',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/fabricante-pneu/editar',
                    name: 'controle-pneus-fabricante-pneu-edit',                    
                    component: () => import('@/views/concept/pneus/fabricantes-pneu/FabricantePneuEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Fabricante Pneu',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/motivo-sucateamento/pesquisar',
                    name: 'controle-pneus-motivo-sucateamento',                    
                    component: () => import('@/views/concept/pneus/motivos-sucateamento/MotivoSucateamento.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Motivos Sucateamento Pneu',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/motivo-sucateamento/editar',
                    name: 'controle-pneus-motivo-sucateamento-edit',                    
                    component: () => import('@/views/concept/pneus/motivos-sucateamento/MotivoSucateamentoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Motivos Sucateamento Pneu',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/dimensoes-pneu/pesquisar',
                    name: 'controle-pneus-dimensao-pneu',                    
                    component: () => import('@/views/concept/pneus/dimensoes-pneu/DimensaoPneu.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Dimensões de Pneus',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/dimensoes-pneu/editar',
                    name: 'controle-pneus-dimensao-pneu-edit',                    
                    component: () => import('@/views/concept/pneus/dimensoes-pneu/DimensaoPneuEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Dimensão de Pneu',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/bandas-rodagem-pneu/pesquisar',
                    name: 'controle-pneus-banda-rodagem-pneu',                    
                    component: () => import('@/views/concept/pneus/bandas-rodagem-pneu/BandaRodagemPneu.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Bandas de Rodagem de Pneus',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/bandas-rodagem-pneu/editar',
                    name: 'controle-pneus-banda-rodagem-pneu-edit',                    
                    component: () => import('@/views/concept/pneus/bandas-rodagem-pneu/BandaRodagemPneuEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Banda de Rodagem de Pneu',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/modelos-pneu/pesquisar',
                    name: 'controle-pneus-modelo-pneu',                    
                    component: () => import('@/views/concept/pneus/modelos-pneu/ModeloPneu.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Modelos de Pneus',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/modelos-pneu/editar',
                    name: 'controle-pneus-modelo-pneu-edit',                    
                    component: () => import('@/views/concept/pneus/modelos-pneu/ModeloPneuEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Modelo de Pneu',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/pneus/pesquisar',
                    name: 'controle-pneus-pneu',                    
                    component: () => import('@/views/concept/pneus/pneus/Pneu.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Pneus',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/pneus/editar',
                    name: 'controle-pneus-pneu-edit',                    
                    component: () => import('@/views/concept/pneus/pneus/PneuEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Pneu',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/movimentacoes-pneus',
                    name: 'controle-pneus-movimentacao-pneu-edit',                    
                    component: () => import('@/views/concept/pneus/movimentacoes-pneu/MovimentacaoPneu.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Movimentações de Pneus',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/gerenciamento-pedidos',
                    name: 'roteirizacao-gerenciamento-pedidos',                    
                    component: () => import('@/views/concept/roteirizacao/gerenciamento-pedidos/GerenciamentoPedidos.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Gerenciamento de Pedidos',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-pneus/inspecoes-pneus',
                    name: 'controle-pneus-inspecao-pneu-edit',                    
                    component: () => import('@/views/concept/pneus/inspecoes-pneus/InspecaoPneu.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Inspeções de Pneu',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/simular-cliente',
                    name: 'configuracao-simular-cliente',                    
                    component: () => import('@/views/concept/configuracao/simular-cliente/SimularCliente.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Alteração de Cliente Ativo',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/tipos-despesa/pesquisar',
                    name: 'frota-tipos-despesa',
                    component: () => import('@/views/concept/frota/tipo-despesas/TipoDespesa.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Tipos de Despesas',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/tipos-despesa/editar',
                    name: 'frota-tipos-despesa-edit',
                    component: () => import('@/views/concept/frota/tipo-despesas/TipoDespesaEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Tipo de Despesa',
                        rule: 'editor'
                    },
                },                
                {
                    path: '/frota/tipos-receita/pesquisar',
                    name: 'frota-tipos-receita',
                    component: () => import('@/views/concept/frota/tipo-receitas/TipoReceita.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Tipos de Receitas',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/tipos-receita/editar',
                    name: 'frota-tipos-receita-edit',
                    component: () => import('@/views/concept/frota/tipo-receitas/TipoReceitaEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Tipo de Receita',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/tipos-ocorrencia-veiculo/pesquisar',
                    name: 'frota-tipos-ocorrencia-veiculo',
                    component: () => import('@/views/concept/frota/tipo-ocorrencias-veiculo/TipoOcorrenciaVeiculo.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Tipos de Ocorrências de Veículos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/tipos-ocorrencia-veiculo/editar',
                    name: 'frota-tipos-ocorrencia-veiculo-edit',
                    component: () => import('@/views/concept/frota/tipo-ocorrencias-veiculo/TipoOcorrenciaVeiculoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Tipo de Ocorrência de Veículo',
                        rule: 'editor'
                    },
                },


                {
                    path: '/frota/ocorrencia-veiculo/pesquisar',
                    name: 'frota-ocorrencia-veiculo',
                    component: () => import('@/views/concept/frota/ocorrencias-veiculo/OcorrenciaVeiculo.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Ocorrências de Veículos',
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/ocorrencia-veiculo/editar',
                    name: 'frota-ocorrencia-veiculo-edit',
                    component: () => import('@/views/concept/frota/ocorrencias-veiculo/OcorrenciaVeiculoEdit.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Ocorrência de Veículo',
                        rule: 'editor'
                    },
                },


                
                {
                    path: '/frota/tipo-item-agenda-evento/pesquisar',
                    name: 'tipo-item-agenda-evento',                    
                    component: () => import('@/views/concept/frota/tipo-item-agenda-evento/TipoItemAgendaEvento.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Tipos Item da Agenda de Evento',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/tipo-item-agenda-evento/editar',
                    name: 'tipo-item-agenda-evento-edit',                    
                    component: () => import('@/views/concept/frota/tipo-item-agenda-evento/TipoItemAgendaEventoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Tipo Item da Agenda de Evento',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/modelo-checklist/pesquisar',
                    name: 'modelo-checklist',                    
                    component: () => import('@/views/concept/frota/checklist/modelo-checklist/ModeloChecklist.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Modelos de Checklist',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/modelo-checklist/editar',
                    name: 'modelo-checklist-edit',                    
                    component: () => import('@/views/concept/frota/checklist/modelo-checklist/ModeloChecklistEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Modelo de Checklist',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/resposta-checklist/pesquisar',
                    name: 'resposta-checklist',                    
                    component: () => import('@/views/concept/frota/checklist/resposta-checklist/RespostaChecklist.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Respostas de Checklists',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/resposta-checklist/inserir',
                    name: 'resposta-checklist-insert',                    
                    component: () => import('@/views/concept/frota/checklist/resposta-checklist/RespostaChecklistInsert.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Inserir Respostas de Checklist',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/resposta-checklist/editar',
                    name: 'resposta-checklist-edit',                    
                    component: () => import('@/views/concept/frota/checklist/resposta-checklist/RespostaChecklistEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Editar Respostas de Checklist',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/resposta-checklist/imprimir',
                    name: 'resposta-checklist-print',                    
                    component: () => import('@/views/concept/frota/checklist/resposta-checklist/ImpressaoRespostaChecklist.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Impressão Respostas de Checklist',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/grupo-despesa/pesquisar',
                    name: 'grupo-despesa',                    
                    component: () => import('@/views/concept/frota/grupos-despesas/GrupoDespesa.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Grupos de Depesas',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/grupo-despesa/editar',
                    name: 'grupo-despesa-edit',                    
                    component: () => import('@/views/concept/frota/grupos-despesas/GrupoDespesaEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Grupo Despesa',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/grupo-receita/pesquisar',
                    name: 'grupo-receita',                    
                    component: () => import('@/views/concept/frota/grupos-receitas/GrupoReceita.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Grupos de Receitas',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/grupo-receita/editar',
                    name: 'grupo-receita-edit',                    
                    component: () => import('@/views/concept/frota/grupos-receitas/GrupoReceitaEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Grupo Receita',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/controle-estoque/categoria-produto/pesquisar',
                    name: 'frota-controle-estoque-categoria-produto',                    
                    component: () => import('@/views/concept/frota/controle-estoque/categoria-produto/CategoriaProduto.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Categorias de Peças',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/controle-estoque/categoria-produto/editar',
                    name: 'frota-controle-estoque-categoria-produto-edit',                    
                    component: () => import('@/views/concept/frota/controle-estoque/categoria-produto/CategoriaProdutoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Categoria de Peças',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/controle-estoque/deposito-produto/pesquisar',
                    name: 'frota-controle-estoque-deposito-produto',                    
                    component: () => import('@/views/concept/frota/controle-estoque/deposito-produto/DepositoProduto.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Depositos de Peças',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/controle-estoque/deposito-produto/editar',
                    name: 'frota-controle-estoque-deposito-produto-edit',                    
                    component: () => import('@/views/concept/frota/controle-estoque/deposito-produto/DepositoProdutoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Depósito de Peças',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/controle-estoque/produto/pesquisar',
                    name: 'frota-controle-estoque-produto',                    
                    component: () => import('@/views/concept/frota/controle-estoque/produto/Produto.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Peças',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/controle-estoque/produto/editar',
                    name: 'frota-controle-estoque-produto-edit',                    
                    component: () => import('@/views/concept/frota/controle-estoque/produto/ProdutoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Peça',                                           
                        rule: 'editor'
                    },
                },


                {
                    path: '/frota/controle-estoque/compra/pesquisar',
                    name: 'frota-controle-estoque-compra',                    
                    component: () => import('@/views/concept/frota/controle-estoque/compras/CompraProduto.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Compras de Peças',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/controle-estoque/compra/editar',
                    name: 'frota-controle-estoque-compra-edit',                    
                    component: () => import('@/views/concept/frota/controle-estoque/compras/CompraProdutoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Compra de Peças',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/lancamento-afericao-odometro-horimetro/pesquisar',
                    name: 'lancamento-afericao-odometro-horimetro',                    
                    component: () => import('@/views/concept/frota/lancamento-afericao-odometro-horimetro/LancamentoAfericaoOdometroHorimetro.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Lançamentos de Aferição de Odômetro e Horímetro',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/lancamento-afericao-odometro-horimetro/editar',
                    name: 'lancamento-afericao-odometro-horimetro-edit',                    
                    component: () => import('@/views/concept/frota/lancamento-afericao-odometro-horimetro/LancamentoAfericaoOdometroHorimetroEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Lançamento de Aferição de Odômetro e Horímetro',                                           
                        rule: 'editor'
                    },
                },                
                {
                    path: '/frota/lancamento-afericao-odometro-horimetro/imprimir',
                    name: 'lancamento-afericao-odometro-horimetro-print',                    
                    component: () => import('@/views/concept/frota/lancamento-afericao-odometro-horimetro/ImpressaoLancamentoAfericao.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Imprimir',                                           
                        rule: 'editor'
                    },
                },


                {
                    path: '/frota/controle-estoque/movimentacao/pesquisar',
                    name: 'frota-controle-estoque-movimentacao',                    
                    component: () => import('@/views/concept/frota/controle-estoque/movimentacao/MovimentacaoEstoque.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Movimentações de Estoque',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/controle-estoque/movimentacao/editar',
                    name: 'frota-controle-estoque-movimentacao-edit',                    
                    component: () => import('@/views/concept/frota/controle-estoque/movimentacao/MovimentacaoEstoqueEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Movimentação de Estoque',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/frota/controle-estoque/veiculo-produto/pesquisar',
                    name: 'frota-controle-estoque-veiculo-produto',                    
                    component: () => import('@/views/concept/frota/controle-estoque/veiculo-produto/VeiculoProduto.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Peças por Veículos',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/controle-estoque/veiculo-produto/editar',
                    name: 'frota-controle-estoque-veiculo-produto-edit',                    
                    component: () => import('@/views/concept/frota/controle-estoque/veiculo-produto/VeiculoProdutoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Peças por Veículo',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizador/log-roteirizador',
                    name: 'roteirizador-log-roteirizador',
                    component: () => import('@/views/concept/roteirizacao/log-roteirizador/LogRoteirizador.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Log Importação',
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/integracao-mastertracker-facchini',
                    name: 'controle-viagens-integracao-mastertracker-facchini',
                    component: () => import('@/views/concept/controle-viagens/integracao-mastertracker-facchini/IntegracaoFacchini.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Integração Facchini',
                        rule: 'editor'
                    },
                },
                {
                    path: '/controle-viagens/integracao-mastertracker-facchini/controlar',
                    name: 'controle-viagens-integracao-mastertracker-facchini-controlar',
                    component: () => import('@/views/concept/controle-viagens/integracao-mastertracker-facchini/ControlarViagemFaccini.vue'),
                    props: true ,
                    meta: {                       
                        pageTitle: 'Controle de Viagem Facchini',
                        rule: 'editor'
                    },
                },


                {
                    path: '/frota/veiculo-externo/pesquisar',
                    name: 'frota-veiculo-externo',                    
                    component: () => import('@/views/concept/frota/veiculos-externo/VeiculoExterno.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Veículos Externos',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/veiculo-externo/editar',
                    name: 'frota-veiculo-externo-edit',                    
                    component: () => import('@/views/concept/frota/veiculos-externo/VeiculoExternoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Veículo Externo',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/gerador-kml-pims',
                    name: 'frota-gerador-kml-pims',                    
                    component: () => import('@/views/concept/percurso/kml-lote/GeradorPIMS.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Gerador KML - PIMS',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/controle-permanencia',
                    name: 'frota-controle-permanencia',                    
                    component: () => import('@/views/concept/frota/controle-permanencia/ControlePermanencia.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Controle de Permanência em Ponto de Interesse'                        
                    },
                },
                {
                    path: '/frota/identificar-veiculo/pesquisar',
                    name: 'identificar-veiculo',                    
                    component: () => import('@/views/concept/frota/identificar-veiculo/IdentificarVeiculo.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Identificação de Trânsito na Área',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/frota/identificar-veiculo/editar',
                    name: 'identificar-veiculo-edit',                    
                    component: () => import('@/views/concept/frota/identificar-veiculo/IdentificarVeiculoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Identificação de Trânsito na Área',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/configuracao/agendador-relatorios/pesquisar',
                    name: 'configuracao-agendador-relatorios',                    
                    component: () => import('@/views/concept/configuracao/agendador-relatorios/AgendadorRelatorios.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Agendador de Relatórios',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/configuracao/agendador-relatorios/editar',
                    name: 'configuracao-agendador-relatorios-edit',                    
                    component: () => import('@/views/concept/configuracao/agendador-relatorios/AgendadorRelatoriosEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Agendador de Relatório',
                        rule: 'editor'
                    },
                },

                {
                    path: '/roteirizacao/status-itinerario-customizado/pesquisar',
                    name: 'roteirizacao-status-itinerario-customizado',                    
                    component: () => import('@/views/concept/roteirizacao/status-itinerario-customizado/StatusItinerarioCustomizado.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Status Itinerários Customizado',                                           
                        rule: 'editor'
                    },
                },
                {
                    path: '/roteirizacao/status-itinerario-customizado/editar',
                    name: 'roteirizacao-status-itinerario-customizado-edit',                    
                    component: () => import('@/views/concept/roteirizacao/status-itinerario-customizado/StatusItinerarioCustomizadoEdit.vue'),
                    props: true ,
                    meta: {    
                        pageTitle: 'Status Itinerários Customizado - Edição',                                           
                        rule: 'editor'
                    },
                },

                {
                    path: '/blank',
                    name: 'blank',                    
                    component: () => import('@/views/pages/NotAuthorized.vue')                    
                },
            ],
        },
        {
            path: '',
            component: () => import('@/layouts/main/MainSemMenu.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                
                {
                    path: '/acesso-temporario/mapa',
                    name: 'acesso-temporario-mapa',
                    component: () => import('@/views/concept/acesso-temporario/AcessoTemporarioHome.vue'),
                    props: true ,
                    meta: {                                               
                        rule: 'editor'
                    },
                },
                
            ]
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

//router.beforeEach((to, from, next) => {
//    firebase.auth().onAuthStateChanged(() => {

        // get firebase current user
    //    const firebaseCurrentUser = firebase.auth().currentUser

        // if (
        //     to.path === "/pages/login" ||
        //     to.path === "/pages/forgot-password" ||
        //     to.path === "/pages/error-404" ||
        //     to.path === "/pages/error-500" ||
        //     to.path === "/pages/register" ||
        //     to.path === "/callback" ||
        //     to.path === "/pages/comingsoon" ||
        //     (auth.isAuthenticated() || firebaseCurrentUser)
        // ) {
        //     return next();
        // }

        // If auth required, check login. If login fails redirect to login page
    //    if(to.meta.authRequired) {
    //      if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
    //        router.push({ path: '/pages/login', query: { to: to.path } })
    //      }
    //    }

    //    return next()
        // Specify the current path as the customState parameter, meaning it
        // will be returned to the application after auth
        // auth.login({ target: to.path });

//    });

//});

export default router
